import * as FieldType from "../constants/FieldType";
import * as CommonConstants from "../constants/CommonConstants";
import {isNullOrUndefined} from "./NamaCommon";
import * as StringConstants from "../constants/StringConstants";
import moment from "moment/moment";

export function parseString(value, type) {
    if (!value)
        return null;
    if (type == FieldType.Reference || type == FieldType.Genericreference) {
        let parts = value.split(CommonConstants.FIELD_PARTS_SEP);
        let id = parts.length > 0 ? parts[0] : "";
        let entityType = parts.length > 1 ? parts[1] : "";
        let code = parts.length > 2 ? parts[2] : "";
        let altCode = parts.length > 3 ? parts[3] : "";
        let name1 = parts.length > 4 ? parts[4] : "";
        let name2 = parts.length > 5 ? parts[5] : "";
        return {
            "id": id,
            "entityType": entityType,
            "code": code,
            "actualCode": altCode,
            "name1": name1,
            "name2": name2,
        };
    }
    return value;
}

export function toString(fieldType, value) {
    if (isNullOrUndefined(value))
        return "";
    if (!fieldType)
        return value;
    let lowerCaseType = fieldType.toLowerCase();
    if (lowerCaseType == FieldType.Reference.toLowerCase() || lowerCaseType == FieldType.Genericreference.toLowerCase() || lowerCaseType == "ENTITYREFERENCE".toLowerCase()) {
        let strVal = value.id + CommonConstants.FIELD_PARTS_SEP + value.entityType + CommonConstants.FIELD_PARTS_SEP
            + value.code + CommonConstants.FIELD_PARTS_SEP
            + value.actualCode + CommonConstants.FIELD_PARTS_SEP + value.name1 + CommonConstants.FIELD_PARTS_SEP + value.name2;
        return strVal;
    }
    if (lowerCaseType === FieldType.Date.toLowerCase()) {
        return kendo.toString(kendo.parseDate(value), StringConstants.dateFormat);
    }
    if (lowerCaseType === FieldType.Time.toLowerCase()) {
        return value.getTime();
    }
    if (lowerCaseType === FieldType.DateAndTime.toLowerCase()) {
        let date = new moment(value, "YYYY-MM-DDTHH:mm:sss.SSS");
        let format = date.format("YYYY-MM-DDTHH:mm:sss.SSS");
        return format;
    }
    return value.toString();
}